export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
            <rect opacity="0.3" x="1.5" y="0.342773" width="24" height="24" fill="#D8D8D8" fillOpacity="0.01" />
            <rect x="6" y="4.84277" width="17" height="12.2" rx="0.5" stroke="url(#paint0_linear_1135_5328)" />
            <rect x="2" y="7.64258" width="17" height="12.2" rx="0.5" fill="#FDF6E8" stroke="url(#paint1_linear_1135_5328)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.4999 9.84277V11.8428L2.5 11.8428V9.84277L18.4999 9.84277Z"
                fill="url(#paint2_linear_1135_5328)"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M6.05956 16.7432V17.66H4.29957V16.7432H6.05956Z" fill="#D09D5C" />
            <path fillRule="evenodd" clipRule="evenodd" d="M9.66015 16.7432V17.66H7.90016V16.7432H9.66015Z" fill="#D09D5C" />
            <defs>
                <linearGradient id="paint0_linear_1135_5328" x1="22" y1="4.54272" x2="6.5" y2="17.5427" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F9D694" />
                    <stop offset="1" stopColor="#C18A48" />
                </linearGradient>
                <linearGradient id="paint1_linear_1135_5328" x1="18" y1="7.34253" x2="2.5" y2="20.3425" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD896" />
                    <stop offset="1" stopColor="#CD9958" />
                </linearGradient>
                <linearGradient id="paint2_linear_1135_5328" x1="18.5" y1="11.8428" x2="2" y2="11.8428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F3CD8B" />
                    <stop offset="1" stopColor="#DBAC6B" />
                </linearGradient>
            </defs>
        </svg>
    );
}
